import React from "react";
import { HiOutlineSparkles } from "react-icons/hi";
import FloatingPopover, {
  FLOATING_POPOVER_MODE,
  FLOATING_POPOVER_PLACEMENT,
  FLOATING_POPOVER_VARIANT,
} from "components/common/FloatingPopover";
import { JOB_STATUS } from "../model/bulkAnalyseModel";
import { useBulkAnalyse } from "../BulkAnalyseContext";

const BulkAnalyseToolbarButton = () => {
  const { enabled, job, counts, etaLabel, openConfirm, openJob } = useBulkAnalyse();
  if (!enabled) return null;

  const running = job?.status === JOB_STATUS.RUNNING;
  const paused = job?.status === JOB_STATUS.STOPPED && !job?.banner_dismissed;
  const holdsTheRun = running || paused;
  const finished = counts.done + counts.failed;
  const totalLabel = counts.total === 1 ? "timesheet" : "timesheets";

  return (
    <FloatingPopover
      mode={FLOATING_POPOVER_MODE.HOVER}
      variant={FLOATING_POPOVER_VARIANT.BRAND}
      placement={FLOATING_POPOVER_PLACEMENT.BOTTOM}
      maxWidth={280}
      zIndex={10080}
      content={
        <div className="px-3.5 py-3 text-left text-[13px] leading-snug text-[#0F172A]">
          {running ? (
            <>
              <p className="font-semibold">
                Bulk Analyse is analysing {finished} of {counts.total} {totalLabel}.
              </p>
              <p className="mt-1 text-[#334155]">
                You can leave this page. Each timesheet gets a score as it completes. {etaLabel}.
              </p>
              <p className="mt-1 text-[#334155]">Click to see the progress.</p>
            </>
          ) : paused ? (
            <>
              <p className="font-semibold">Bulk Analyse is paused.</p>
              <p className="mt-1 text-[#334155]">
                Resume it before starting another. Click to open this analysis.
              </p>
            </>
          ) : (
            <>
              <p className="font-semibold">Bulk Analyse</p>
              <p className="mt-1 text-[#334155]">
                Reviews a set of timesheets with AI, instead of opening them one by one. Each timesheet gets a score and the issues to look at.
              </p>
              <p className="mt-1 text-[#334155]">
                You still approve or reject every timesheet yourself.
              </p>
            </>
          )}
        </div>
      }
    >
      <button
        type="button"
        onClick={holdsTheRun ? openJob : openConfirm}
        aria-label={
          running
            ? "Bulk analyse is running. Open this analysis."
            : paused
              ? "Bulk analyse is paused. Open this analysis."
              : "Bulk analyse"
        }
        className={`timesheet-bulk-toolbar__btn border shadow-sm ${
          holdsTheRun
            ? "border-[#4B6CB7] bg-[#4B6CB7] text-white hover:bg-[#3E5CA3]"
            : "border-[#4B6CB7] bg-[#ECF0FD] text-[#293F6A] hover:bg-[#DDE5F8]"
        }`}
      >
        {running ? (
          <span className="inline-block h-3.5 w-3.5 shrink-0 animate-spin rounded-full border-2 border-white/40 border-t-white" />
        ) : (
          <HiOutlineSparkles className={`h-4 w-4 shrink-0 ${holdsTheRun ? "text-white" : "text-[#4B6CB7]"}`} />
        )}
        {running ? "Running" : paused ? "Paused" : "Bulk Analyse"}
      </button>
    </FloatingPopover>
  );
};

export default BulkAnalyseToolbarButton;
